import * as waitlist from "./waitlist";
import * as inference from "./inference";
import * as auth from "./auth";
import * as guestAuth from "./guestAuth";
import * as core from "./core";
import * as workspace from "./workspace";
import * as analytics from "./analytics";
import * as video from "./video";
import * as creditPromo from "./creditPromo";
import * as datasets from "./datasets";

export type Api = {
    auth: typeof auth;
    guestAuth: typeof guestAuth;
    core: typeof core;
    workspace: typeof workspace;
    waitlist: typeof waitlist;
    inference: typeof inference;
    analytics: typeof analytics;
    video: typeof video;
    creditPromo: typeof creditPromo;
    datasets: typeof datasets;
};

const api: Api = {
    auth,
    guestAuth,
    core,
    workspace,
    datasets,
    waitlist,
    inference,
    analytics,
    video,
    creditPromo
};

export default api;
